import { Group } from "../types/user-groups/Group";
import { axiosWithAuth } from "../utils/customAxios";
import { ApiResponse } from "../types/ApiResponse";

const userGroupsService = {
  getUserGroups: async (): Promise<Group[]> => {
    try {
      const response = await axiosWithAuth.get(`/group`);
      const groups: Group[] = response.data;
      return groups;
    } catch (ex) {
      throw ex;
    }
  },

  getRecordingNetworkGroups: async (userId: number): Promise<Group[]> => {
    try {
      const response = await axiosWithAuth.get(`/group/recordingnetwork/${userId}`);
      const groups: Group[] = response.data;
      return groups;
    } catch (ex) {
      throw ex;
    }
  },

  fetchAllGroupsPaginated: async (skip: number = 0, take: number = 20, searchValue: string = ''): Promise<ApiResponse<Group>> => {
    try {
      const route = `/group/all?skip=${skip}&take=${take}&name=${searchValue}`;
      const response = await axiosWithAuth.get(route);
      const groups: ApiResponse<Group> = response.data;
      return groups;
    } catch (err) {
      throw err;
    }
  },

  upsertUserGroup: async (group: Group): Promise<Group> => {
    try {
      if (group.id > 0) {
        const response = await axiosWithAuth.put(`/group`, group);
        const upsertedGroup: Group = response.data;
        return upsertedGroup;
      } else {
        const response = await axiosWithAuth.post(`/group`, group);
        const upsertedGroup: Group = response.data;
        return upsertedGroup;
      }
    } catch (ex) {
      throw ex;
    }
  },

  deleteUserGroups: async (id: number): Promise<Group[]> => {
    try {
      const response = await axiosWithAuth.delete(`/group/${id}`);
      return response.data;
    } catch (ex) {
      throw ex;
    }
  },
};

export default userGroupsService;
